export const VARIANT_MAX_LIMIT = 5;
export const VARIANT_MIN_LIMIT = 2;
export var RuleDragType;
(function (RuleDragType) {
    RuleDragType["ProductPreview"] = "productPreview";
    RuleDragType["ChipTier"] = "chipTier";
})(RuleDragType || (RuleDragType = {}));
